module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/chevronDownVA.86c4afc1.svg";